import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Popover, PopoverContent, PopoverTrigger } from '@Components/ui-v2/popover';
import AgentBrand from './AgentBrand';
import ConversationListBody from './ConversationListBody';

const SessionDropdown = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <AgentBrand onClick={() => setOpen((v) => !v)} />
      </PopoverTrigger>
      <PopoverContent
        align="start"
        side="bottom"
        sideOffset={6}
        className="agent-root z-[120] flex h-[420px] w-[300px] flex-col overflow-hidden rounded-xl border border-gray-200 bg-[#fbfaf9] p-0 shadow-xl">
        <div className="flex h-10 flex-shrink-0 items-center border-b border-gray-200 px-4">
          <span className="text-xs font-semibold uppercase tracking-wider text-gray-500">
            {t('Agent.ConversationsListTitle')}
          </span>
        </div>
        <ConversationListBody compact onAfterSwitch={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
};

export default SessionDropdown;
